var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('model-form',_vm._b({attrs:{"no-buttons":""},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}},'model-form',_vm.formProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }